import { useEffect } from 'react'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { CheckCircle2, Home } from 'lucide-react'

export default function AnamneseCompletaPage() {

  useEffect(() => {
    // Rolar para o topo
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }, [])

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 p-4">
      <div className="max-w-2xl mx-auto py-8">
        <Card className="shadow-lg">
          <CardHeader className="text-center">
            <div className="flex justify-center mb-4">
              <CheckCircle2 className="h-16 w-16 text-green-500" />
            </div>
            <CardTitle className="text-2xl text-green-700">
              Formulário Já Preenchido
            </CardTitle>
            <CardDescription>
              Este formulário de anamnese já foi preenchido e enviado com sucesso.
            </CardDescription>
          </CardHeader>
          <CardContent className="space-y-6 text-center">
            <div className="bg-green-50 border border-green-200 rounded-lg p-4">
              <p className="text-green-800">
                Agradecemos sua participação! Este link de acesso já foi utilizado
                e não pode ser preenchido novamente.
              </p>
            </div>
            
            <div className="space-y-3">
              <p className="text-gray-600">
                Caso precise preencher um novo formulário ou tenha dúvidas,
                entre em contato com a residencial responsável.
              </p>
              
              <Button
                onClick={() => window.location.href = 'https://idmovi.com'}
                className="w-full sm:w-auto"
              >
                <Home className="mr-2 h-4 w-4" />
                Ir para Página Inicial
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  )
}
